export const VERSION = {
  PROD: 'V. 3.2.0',
  QA: 'V. 4.1.0 (QA)',
}
